/**
 * Labstep
 *
 * @module components/OrderRequest/EmptyState/ResourceItem
 * @desc Empty state for OrderRequest with ResourceItem
 */

import { ResourceItemActionImport } from 'labstep-web/components/ResourceItem/Action/Import';
import { CardEmptyState } from 'labstep-web/core/Card/EmptyState';
import type React from 'react';
import type { OrderRequestEmptyStateResourceItemProps } from './types';

export const OrderRequestEmptyStateResourceItem: React.FC<
  OrderRequestEmptyStateResourceItemProps
> = ({ orderRequest }) => (
  <CardEmptyState
    title="No items have been added to inventory yet."
    explanation={`Once the items from this request have been received click below to add the new items of ${orderRequest.resource.name} to your inventory.`}
    src="/img/empty-state/orderRequests.svg"
    action={
      <ResourceItemActionImport
        resource={orderRequest.resource}
        orderRequest={orderRequest}
        actionComponentProps={{
          type: 'button',
          text: 'Add Items to Inventory',
        }}
      />
    }
  />
);
